import $ from 'jquery'
import 'jquery-csv'
import Mutations from './mutations'
import Utils from './util'
import { namespace } from './env'

export default class Actions {
  constructor () {
    this.mutationInstance = new Mutations()
    this.utilsInstance = new Utils()
    this.thumbnails = {
      url1: `${process.env.GET_PROPERTY_DATA}share/TjGHg/kimg/{物件ID}/1_1-s.jpg`,
      url2: `${process.env.GET_PROPERTY_DATA}share/TjGHg/kimg/{物件ID}/2_1.jpg`
    }
  }

  getInventoryProperty () {
    const req = new XMLHttpRequest()
    req.addEventListener('load', e => {
      const res = e.target.responseText
      this.csv2array(res)
    })
    req.open('GET', `${process.env.GET_PROPERTY_DATA}share/csv/touei_bukken_data.csv`, true)
    req.overrideMimeType('text/csv; charset=Shift_JIS')
    req.send()
  }

  csv2array (data) {
    const arr = []
    const csvData = $.csv.toArrays(data.replace(/(<([^>]+)>)/gi, ''))
    const keys = csvData[0]
    const values = csvData.slice(1, csvData.length)

    values.map((item) => {
      let cell = new Object()

      for (let i = 0; i < keys.length; i++) {
        cell[keys[i]] = item[i]
      }
      arr.push(cell)
    })

    this.shapingRailwayData(arr)
  }

  async shapingRailwayData (array) {
    const { nearestLines } = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))
    let properties = []
    const { Routes } = JSON.parse(sessionStorage.getItem(namespace.STATIONS_JSON))

    await Promise.all(array.map(async (item) => {
      let obj = new Object()

      for (let i = 0; i < Routes.length; i++) {
        if (item[nearestLines.line1].includes(Routes[i].RouteName)) {
          obj = Object.assign({}, item)
          obj = await this.addAnyProperty(obj, item, nearestLines.line1)
          properties.push(obj)
        } else if (item[nearestLines.line2].includes(Routes[i].RouteName)) {
          obj = Object.assign({}, item)
          obj = await this.addAnyProperty(obj, item, nearestLines.line2)
          properties.push(obj)
        } else if (item[nearestLines.line3].includes(Routes[i].RouteName)) {
          obj = Object.assign({}, item)
          obj = await this.addAnyProperty(obj, item, nearestLines.line3)
          properties.push(obj)
        } else if (item[nearestLines.line4].includes(Routes[i].RouteName)) {
          obj = Object.assign({}, item)
          obj = await this.addAnyProperty(obj, item, nearestLines.line4)
          properties.push(obj)
        } else if (item[nearestLines.line5].includes(Routes[i].RouteName)) {
          obj = Object.assign({}, item)
          obj = await this.addAnyProperty(obj, item, nearestLines.line5)
          properties.push(obj)
        }
      }
    }))

    sessionStorage.setItem(namespace.ORIGINAL_PROPERTIES, JSON.stringify(properties))
    this.mutationInstance.setRailwayData(properties)
    this.mutationInstance.setShapingData(properties)
  }

  async addAnyProperty (obj, item, condition) {
    let conditions = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))
    let thumbnail = await this.getInventoryImage(obj['物件ID'])
    obj['物件画像'] = thumbnail
    obj['物件詳細URL'] = `${process.env.GET_PROPERTY_DATA}details/${item['物件番号']}`
    obj[conditions.extractedRailLineInformation] = condition

    let rangePrice = 0
    if (String(obj[conditions.rangeForSale]).length) {
      rangePrice = this.priceFormat(item, 'rangeForSale')
    } else if (String(obj[conditions.rangeOfLandForSale]).length) {
      rangePrice = this.priceFormat(item, 'rangeOfLandForSale')
    } else if (String(obj[conditions.conditionalPriceRange]).length) {
      rangePrice = this.priceFormat(item, 'conditionalPriceRange')
    }
    obj[conditions.forDetermination] = rangePrice

    return obj
  }

  priceFormat (item, key) {
    let conditions = JSON.parse(sessionStorage.getItem(namespace.CONDITION_JSON))

    const wavyLine = /(~|〜|～)/
    let price = 0
    if (item[conditions[key]].length && !wavyLine.test(item[conditions[key]])) {
      price = Number(this.replaceStr(item[conditions[key]]))
    } else if (item[conditions[key]].length && wavyLine.test(item[conditions[key]])) {
      let range = item[conditions[key]].split(wavyLine)
      price = Number(this.replaceStr(range[0]))
    } else if (!item[conditions[key]]) {
      price = 0
    }

    return price
  }

  replaceStr (val) {
    let str = ''
    str = val.replace(',', '')
    str = str.replace('万円', '')
    return str
  }

  async getInventoryImage (propertyId) {
    let res = {}
    try {
      res = await this.fetchImage(this.thumbnails.url1.replace('{物件ID}', propertyId))

      if (res.status !== 200) {
        res = await this.fetchImage(this.thumbnails.url2.replace('{物件ID}', propertyId))
      }
      return res.url
    } catch (error) {
      console.log(error)
    }
  }

  async fetchImage (url) {
    let res = {}
    res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'image/jpeg'
      }
    })

    return res
  }

  commitPagination (num) {
    this.mutationInstance.transitionViewPropertyData(num)
  }
}
